import { WidgetContext } from 'components/Widget/Widget';
import { useContext } from 'react';

export const useWidget = () => useContext(WidgetContext);
